import { Currency } from '@mobi/utils/money'

/** Kambi currency is represented by integers - 1000 times dollar value rounded down to the nearest cent
 *  ie. 3575 is $3.57 (3575 / 1000) */
export const formatKambiCurrencyToDollarDecimal = (amount: number) => {
  const floorAmount = amount - (amount % 10)
  return new Currency(floorAmount, { dollarMultiplier: 1_000 }).value
}

export const formatDollarDecimalToThousandMultiplier = (amount: number) => {
  return Math.floor(amount * 1_000)
}
